import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { JVDate } from "../../shared/JVDate";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { IFrequencyTable } from "./FrequencyTable";
import { JVTime } from "../../shared/JVTime";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    singleData: IFrequencyTable,
    hideDialog: () => void,
    toast: any
}

interface IFrequencyTime {
    id?: number | null,
    timesheets_Frequency_Setting_ID?: number | null,
    email_Time: Date | null,
}

interface IFrequencyTimeTable {
    id?: number,
    timesheets_Frequency_Setting_ID?: number,
    email_Time?: Date,
    update_By?: string,
    updated_On?: Date,
}

const schema = yup.object({
    timesheets_Frequency_Setting_ID: yup.number().nullable(),
    email_Time: yup.date().required("Email Sending Time is required").typeError("Email Sending Time is required"),
});

export const FrequencyTableTime = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IFrequencyTimeTable[], loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<IFrequencyTime>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        reset({ id: null, timesheets_Frequency_Setting_ID: null, email_Time: null, });
        setTableData({ tableData: [], loading: false });
        setLoading(false);
        props.hideDialog();
    }

    const updatedOn = (rowData: any) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const header = () => {
        return <p></p>;
    }

    const onSubmit = async (data: IFrequencyTime) => {
        data.timesheets_Frequency_Setting_ID = props.singleData.id;
        //console.log(data);
        data.email_Time = new Date(new Date(data.email_Time || "").getTime() - 5 * 60 * 60 * 1000);

        setLoading(true);
        const endPOint: string = (data.id !== undefined && data.id !== null && data.id !== 0 && data.id > 0) ? "updateSendEmailFrequencyTime" : "addSendEmailFrequencyTime";
        console.log(data);
        if (data.id === null || data.id === undefined) {
            delete data.id;
        };

        const response = await Fetch(`Timesheet/${endPOint}`, (endPOint === "updateSendEmailFrequencyTime" ? "PUT" : "POST"), data, null, props.toast);
        if (response) {
            setLoading(false);
            reset({ timesheets_Frequency_Setting_ID: null, email_Time: null, });
            loadTableData();
        } else setLoading(false);
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch(`Timesheet/getSendEmailFrequencyTime`, "GET", null, `id=${props.singleData.id}`, props.toast);
        if (response) {
            const data: Array<IFrequencyTimeTable> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const actionBodyTemplate = (rowData: IFrequencyTimeTable) => {
        const data: IFrequencyTimeTable = { id: rowData.id, timesheets_Frequency_Setting_ID: rowData.timesheets_Frequency_Setting_ID, email_Time: new Date(rowData?.email_Time || "") };
        return (
            <div className="actions">
                <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => reset(data)} />
            </div>
        );
    };

    useEffect(() => {
        if (props.open && props.singleData.id) {
            loadTableData();
        }
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Frequency Time" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVTime required column={3} label="Email Time" control={control} name="email_Time" error={errors.email_Time?.message} />

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CEAR" onClick={() => reset({ timesheets_Frequency_Setting_ID: null, email_Time: null, })} type="button"></Button>
                </div>
            </form>
            <div className="mt-2"></div>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", height: "60vh" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="email_Time" header="Send Email Time" body={(rowData: any) => {
                    const date = new Date(rowData.email_Time);

                    const time = date.toLocaleString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true
                    });

                    return <p>{time}</p>
                }} />
                <Column field="update_By" header="Update By" />
                {/* <Column field="updated_On" header="Updated On" body={updatedOn} /> */}
                <Column field="updated_On" header="Updated On" body={(rowData: any ) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat, true)} />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </Dialog>
    );
}